import { datadogRum } from '@datadog/browser-rum';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { getDatadogViewName } from '@helpers/datadogViewName';

import { getLocaleState } from '@redux/selectors';

/**
 * @description React component that listens to route changes and updates Datadog RUM view name.
 */
const DatadogViewTracker: React.FC = () => {
  const location = useLocation();
  const locale = useSelector(getLocaleState);

  useEffect(() => {
    const viewName = getDatadogViewName(locale, location.pathname, location.search);
    datadogRum.startView(viewName);
  }, [locale, location.pathname, location.search]);

  return null;
};

export default DatadogViewTracker;
